import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { UserModel } from 'app/core/models/user.model';
import { AppSettings } from '../../service/app-settings.service';
import { StoreStateService, USER_AUTHENTICATION_SERVICE, UserAuthInterface } from 'app/core/services';
import { Component, Input, Output, EventEmitter, Renderer2, OnDestroy, Inject, OnInit } from '@angular/core';
import { PullDataFormComponent } from 'app/core/components/pull-data-form.component';
import { modalLgOptions, modalMdOptions, modalXlOptions } from 'app/core/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppMenuService } from 'app/service/app-menus.service';
import { MenuFilterModalComponent } from '../menu-filter-modal/menu-filter-modal.component';
import { CustomStore } from 'devextreme/common/data';
import { SignalRNotificationService } from 'app/core/services/signalr.service';
import { SignalRNotificationModel } from 'app/core/models';
import { COMMON_SERVICE, CommonInterface } from 'app/core/services/common.interface';
declare var slideToggle: any;
@Component({
  selector: 'header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() appSidebarTwo;
  @Output() appSidebarEndToggled = new EventEmitter<boolean>();
  @Output() appSidebarMobileToggled = new EventEmitter<boolean>();
  @Output() appSidebarEndMobileToggled = new EventEmitter<boolean>();
  @Output() notificationPanelToggled = new EventEmitter<boolean>();

  currentUser: UserModel;
  selectedStoreId: number | string | null = null;
  subscription: Subscription = new Subscription();

  dataSource: CustomStore;
  notifications: any[] = [];
  unreadCount: number = 0;
  showAll = false;

  //#region Constructor
  constructor(
    private renderer: Renderer2,
    private _router: Router,
    public appSettings: AppSettings,
    private _storeState: StoreStateService,
    private appMenuService: AppMenuService,
    private _signalRService: SignalRNotificationService,
    @Inject(NgbModal) private _ngbModalService: NgbModal,
    @Inject(COMMON_SERVICE) private _commonService: CommonInterface,
    @Inject(USER_AUTHENTICATION_SERVICE) private _userAuthInterface: UserAuthInterface,
  ) { };
  //#endregion
  //#region Methods
  ngOnInit(): void {
    this.currentUser = this._userAuthInterface.authenticatedUser;

    const token = this._userAuthInterface.authenticatedUser?.token;
    this._signalRService.startConnection(token);

    // this.subscription.add(
    //   this._signalRService.notifications$.subscribe(n => this.notifications = n)
    // );
    this.subscription.add(
      this._signalRService.unreadCount$.subscribe(c => this.unreadCount = c)
    );

    this.subscription.add(
      this._signalRService.notifications$.subscribe(() => this.loadUnreadCount())
    );
    // this.loadUnreadCount();
  }

  goToProfile() {
    this._router.navigate(['user/user-profile']);
  }

  toggleAppSidebarMobile() {
    this.appSidebarMobileToggled.emit(true);
  }

  toggleAppSidebarEnd() {
    this.appSidebarEndToggled.emit(true);
  }

  toggleAppSidebarEndMobile() {
    this.appSidebarEndMobileToggled.emit(true);
  }

  toggleNotificationPanel() {
    this.notificationPanelToggled.emit(true);
  }

  toggleAppTopMenuMobile() {
    var target = document.querySelector('.app-top-menu');
    if (target) {
      slideToggle(target);
    }
  }

  toggleAppHeaderMegaMenuMobile() {
    this.appSettings.appHeaderMegaMenuMobileToggled = !this.appSettings.appHeaderMegaMenuMobileToggled;
  }

  ngOnDestroy() {
    this.appSettings.appHeaderMegaMenuMobileToggled = false;
    this.subscription?.unsubscribe();
  }

  // logoutUser() {
  //   this._userAuthInterface.logoutUser();
  //   this._storeState.clearStore();
  //   this._router.navigate(['/account/login']);
  // };

  logoutUser() {
    this._userAuthInterface.logoutUser().subscribe({
      next: () => {
        this._storeState.clearStore();
        this._router.navigate(['/account/login']);
      },
      error: () => {
        this._storeState.clearStore();
        this._router.navigate(['/account/login']);
      }
    });
  }

  onPullData() {
    let options = this._ngbModalService.open(PullDataFormComponent, modalLgOptions);
    options.result.then(
      (result) => {
        console.log('Modal closed with result:', result);
      },
      (reason) => {
        console.log('Modal dismissed with reason:', reason);
      }
    )
  }

  onGlobalSearch(event: KeyboardEvent) {
    const input = (event.target as HTMLInputElement).value.toLowerCase();
    if (!input) return;

    const menus = this.appMenuService.getAppMenus();
    const filteredMenus = this.filterMenus(menus, input);

    if (filteredMenus.length > 0) {
      this.openMenuFilterModal(filteredMenus);
    }
  }

  private filterMenus(menus: any[], searchText: string): any[] {
    return menus
      .map(menu => {
        const filteredSubmenu = menu.submenu ? this.filterMenus(menu.submenu, searchText) : [];
        if (menu.title.toLowerCase().includes(searchText) || filteredSubmenu.length > 0) {
          return { ...menu, submenu: filteredSubmenu };
        }
        return null;
      })
      .filter(menu => menu !== null);
  }

  private openMenuFilterModal(filteredMenus: any[]) {
    const modalRef = this._ngbModalService.open(MenuFilterModalComponent, modalLgOptions);
    modalRef.componentInstance.filteredMenus = filteredMenus;

    modalRef.result.then(
      (result) => console.log('Modal closed with result:', result),
      (reason) => console.log('Modal dismissed:', reason)
    );
  }

  loadUnreadCount(): void {
    this._commonService.getNotificationsUnreadCount().subscribe({
      next: (res) => {
        this.unreadCount = res.data ?? 0;
      },
      error: (err) => console.error('Failed to load unread count:', err)
    });
  }

  //#endregion
}